

// Swiper Initialization
new Swiper('.spa-category-slider', {
  slidesPerView: 1.15,
  spaceBetween: 12
});

new Swiper('.booking-slider', {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
      nextEl: ".booking-slider__nav--next",
      prevEl: ".booking-slider__nav--prev",
    },
});

new Swiper('.booking-location-slider', {
  slidesPerView: 1,
  spaceBetween: 10,
  navigation: {
      nextEl: ".booking-slider__nav--next",
      prevEl: ".booking-slider__nav--prev",
    },
});


const faqItems = document.querySelectorAll('.service-faq__item');

faqItems.forEach(item => {
  const trigger = item.querySelector('.service-faq__trigger');
  const content = item.querySelector('.service-faq__content');

  // Open default active item
  if (item.classList.contains('is-active')) {
    content.style.height = content.scrollHeight + 'px';
  }

  trigger.addEventListener('click', () => {
    const isActive = item.classList.contains('is-active');

    // Close all items
    faqItems.forEach(faq => {
      faq.classList.remove('is-active');
      faq.querySelector('.service-faq__content').style.height = '0px';
    });

    // Open clicked item
    if (!isActive) {
      item.classList.add('is-active');
      content.style.height = content.scrollHeight + 'px';
    }
  });
});

/* BEFORE / AFTER */

new Swiper('.service-results-slider', {
  slidesPerView: 1,
  spaceBetween: 0,
  navigation: {
    nextEl: '.booking-slider__nav--next',
    prevEl: '.booking-slider__nav--prev'
  }

});


/* RELATED */

new Swiper('.service-related-slider', {
  slidesPerView: 1.1,
  spaceBetween: 12
});

// video
var spScrollVideo = document.querySelectorAll(`.service-book-video video`);
if (spScrollVideo.length > 0) {
    for (var x = 0; x < spScrollVideo.length; x++) {
        spScrollVideo[x].closest(".service-book-video").querySelectorAll(".service-play-pause-btn").forEach(playPauseBtn => {
            playPauseBtn.addEventListener("click", function () {
                this.closest(".service-book-video").querySelector(".service-active").classList.remove("service-active");
                if (this.closest(".service-book-video").querySelector("video").paused) {
                    this.closest(".service-book-video").querySelector(".service-play-btn").classList.add("service-active");
                    this.closest(".service-book-video").querySelector("video").play();
                } else {
                    this.closest(".service-book-video").querySelector(".service-pause-btn").classList.add("service-active");
                    this.closest(".service-book-video").querySelector("video").pause();
                }
            });
        });
    }
}

/*-----------*/
/* ==========================================================
   BOOKING FLOW
========================================================== */

document.addEventListener('DOMContentLoaded', function () {

  
  /* --------------------------
     STEP SECTIONS
  -------------------------- */

  const step1 = document.querySelector('.booking-step-1');
  const step2 = document.querySelector('.booking-step-2');
  const step3 = document.querySelector('.booking-step-3');

  /* --------------------------
     STEP 3 PAGES
  -------------------------- */

  const specialistPage = document.querySelector('.booking-page-specialist');
  const clientPage = document.querySelector('.booking-page-client');
  const dateTimePage = document.querySelector('.booking-page-datetime');

    /* --------------------------
     BACK BUTTON
  -------------------------- */
  document.querySelectorAll('.booking-back-button')
  .forEach(button => {
    button.addEventListener('click', function () {
      const target = this.dataset.back;

      switch (target) {

        case 'spa-menu':
          step2.style.display = 'none';
          step1.style.display = 'block';
          break;

        case 'treatment':
          step3.style.display = 'none';
          step2.style.display = 'block';
          break;

        case 'specialist':
          clientPage.style.display = 'none';
          specialistPage.style.display = 'block';
          break;

        case 'client':
          dateTimePage.style.display = 'none';
          clientPage.style.display = 'block';
          break;

      }
    });
  });


  /* --------------------------
     STEP 1 → STEP 2
  -------------------------- */

  document.querySelectorAll('.spa-menu__button').forEach(button => {

    button.addEventListener('click', function (e) {

      e.preventDefault();

      if (step1) step1.style.display = 'none';
      if (step2) step2.style.display = 'block';

    });

  });

  /* --------------------------
     STEP 2 → STEP 3
  -------------------------- */

  document.querySelectorAll('.treatment-card__cta').forEach(button => {

    button.addEventListener('click', function (e) {

      e.preventDefault();

      if (step2) step2.style.display = 'none';
      if (step3) step3.style.display = 'block';

      if (specialistPage) specialistPage.style.display = 'block';
      if (clientPage) clientPage.style.display = 'none';
      if (dateTimePage) dateTimePage.style.display = 'none';

    });

  });

  /* --------------------------
     SPECIALIST SELECTION
  -------------------------- */

  const specialistContinueBtn =
    document.getElementById('continueButton');

  const specialistOptions =
    document.querySelectorAll('input[name="specialist"]');

  if (specialistContinueBtn) {

    specialistOptions.forEach(option => {

      option.addEventListener('change', function () {

        specialistContinueBtn.disabled = false;

      });

    });

    specialistContinueBtn.addEventListener('click', function (e) {

      e.preventDefault();

      if (specialistContinueBtn.disabled) return;

      if (specialistPage) specialistPage.style.display = 'none';
      if (clientPage) clientPage.style.display = 'block';

    });

  }

  /* --------------------------
     CLIENT TYPE SELECTION
  -------------------------- */

  const clientContinueBtn =
    document.getElementById('bookingContinueBtn');

  const clientTypeInputs =
    document.querySelectorAll('.booking-client-card__input');

  if (clientContinueBtn) {

    clientTypeInputs.forEach(input => {

      input.addEventListener('change', function () {

        clientContinueBtn.disabled = false;

      });

    });

    clientContinueBtn.addEventListener('click', function (e) {

      e.preventDefault();

      if (clientContinueBtn.disabled) return;

      if (clientPage) clientPage.style.display = 'none';
      if (dateTimePage) dateTimePage.style.display = 'block';

    });

  }

  // Spacilist select
  const continueBtn = document.querySelector(
    '.booking-action-footer__button'
  );
  const specialistRadios = document.querySelectorAll(
    '.specialist-selection-card__input'
  );
  specialistRadios.forEach((radio) => {
    radio.addEventListener('change', function () {
      continueBtn.classList.remove(
        'booking-action--disabled'
      );
      continueBtn.classList.add(
        'booking-action--active'
      );
    });
  });
});